import { apiEndpoint } from '@/lib/constants';
import { authStore } from '@/store/useAuthStore';
import axiosInstance from './api';

export interface HeartbeatPayload {
  tab_id: string;
  client_timestamp?: string;
  page_url?: string;
  is_visible?: boolean;
  is_closing?: boolean;
}

export interface HeartbeatResponse {
  status: boolean;
  message: string;
  error: string | null;
  data: {
    active_seconds?: number;
  };
}

const heartbeatPath = 'auth/heartbeat/';

const getHeartbeatUrl = () =>
  `${apiEndpoint.replace(/\/$/, '')}/${heartbeatPath}`;

const sendHeartbeat = async (
  payload: HeartbeatPayload,
): Promise<HeartbeatResponse> => {
  const response = await axiosInstance.post(heartbeatPath, payload);
  return response.data;
};

const sendClosingHeartbeat = (payload: HeartbeatPayload) => {
  const token = authStore.getState().token;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  void fetch(getHeartbeatUrl(), {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch((error: unknown) => {
    console.error('Closing heartbeat failed', error);
  });
};

export const heartbeatService = {
  sendHeartbeat,
  sendClosingHeartbeat,
};
